<template>
  <div>
    <div class="logo-wrap">
      <img src="/img/bytbostad.svg" alt="BytBostad">
    </div>
    <div class="form-container">
      <h1>Kontroll</h1>
      
      <!-- Step 1: Still living at address -->
      <div v-if="currentStep === 1" class="step">
        <p class="question">Bor du kvar på <strong>{{ address }}</strong>?</p>
        <div class="button-group">
          <button @click="stillAtAddress(true)" class="btn btn-primary">Ja</button>
          <button @click="stillAtAddress(false)" class="btn btn-secondary">Nej</button>
        </div>
      </div>

      <!-- Step 2a: No longer at address - still in rental? -->
      <div v-if="currentStep === 2 && !answers.stillAtAddress" class="step">
        <p class="question">Bor du fortfarande i en hyresrätt?</p>
        <div class="button-group">
          <button @click="stillInRental(true)" class="btn btn-primary">Ja</button>
          <button @click="stillInRental(false)" class="btn btn-secondary">Nej</button>
        </div>
      </div>

      <!-- Step 2b: Still at address - still want to swap? -->
      <div v-if="currentStep === 2 && answers.stillAtAddress" class="step">
        <p class="question">Vill du fortfarande byta din bostad?</p>
        <div class="button-group">
          <button @click="stillWantsSwap(true)" class="btn btn-primary">Ja</button>
          <button @click="stillWantsSwap(false)" class="btn btn-secondary">Nej</button>
        </div>
      </div>

      <!-- Step 3a: Confirm rental details -->
      <div v-if="currentStep === 3 && answers.stillWantsSwap" class="step">
        <p class="question">Vänligen bekräfta eller uppdatera dina uppgifter:</p>
        <form @submit.prevent="submitDetails" class="details-form">
          <div class="form-group">
            <label for="rent">Månadshyra (kr):</label>
            <input 
              type="number" 
              id="rent" 
              v-model.number="details.rent" 
              required
              class="form-input"
            >
          </div>
          <div class="form-group">
            <label for="rooms">Antal rum:</label>
            <input 
              type="number" 
              id="rooms" 
              v-model.number="details.rooms" 
              required
              step="0.5"
              class="form-input"
            >
          </div>
          <div class="form-group">
            <label for="sqm">Storlek (kvm):</label>
            <input 
              type="number" 
              id="sqm" 
              v-model.number="details.sqm" 
              required
              class="form-input"
            >
          </div>
          <button type="submit" class="btn btn-primary">Bekräfta</button>
        </form>
      </div>

      <!-- Final messages -->
      <div v-if="currentStep === 'final'" class="step final-message">
        <!-- No longer at address, not in rental -->
        <div v-if="!answers.stillAtAddress && !answers.stillInRental">
          <p class="success-message">✓ Tack för din medverkan!</p>
          <p>Vi har uppdaterat dina uppgifter.</p>
        </div>

        <!-- No longer at address, still in rental -->
        <div v-if="!answers.stillAtAddress && answers.stillInRental">
          <p class="success-message">Vill du bo större? Billigare?</p>
          <p>Lägg upp din hyresrätt här för att byta den mot en som passar dig bättre.</p>
          <button @click="goToNewListing" class="btn btn-primary">Lägg upp din bostad</button>
        </div>

        <!-- Still at address, no longer wants to swap -->
        <div v-if="answers.stillAtAddress && !answers.stillWantsSwap">
          <p class="success-message">✓ Tack för att du hörde av dig!</p>
          <p>Om du ändrar dig är du välkommen tillbaka!</p>
        </div>

        <!-- Still at address, still wants to swap, details confirmed -->
        <div v-if="answers.stillAtAddress && answers.stillWantsSwap && detailsConfirmed">
          <p class="success-message">✓ Tack! Dina uppgifter är uppdaterade.</p>
          <div class="discount-offer">
            <h3>Särskilt erbjudande!</h3>
            <p>Som tack för att du uppdaterat dina uppgifter erbjuder vi dig rabatterat medlemskap.</p>
            <button @click="claimDiscount" class="btn btn-primary">Se erbjudande</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InactiveUserCheckIn',
  data() {
    return {
      currentStep: 1,
      address: '[GATUADRESS]', // This should be passed as a prop or fetched from API
      answers: {
        stillAtAddress: null,
        stillInRental: null,
        stillWantsSwap: null
      },
      details: {
        rent: null,
        rooms: null,
        sqm: null
      },
      detailsConfirmed: false
    }
  },
  methods: {
    stillAtAddress(answer) {
      this.answers.stillAtAddress = answer;
      this.currentStep = 2;
    },
    stillInRental(answer) {
      this.answers.stillInRental = answer;
      this.currentStep = 'final';
      this.submitResponses();
    },
    stillWantsSwap(answer) {
      this.answers.stillWantsSwap = answer;
      if (answer) {
        this.currentStep = 3;
      } else {
        this.currentStep = 'final';
        this.submitResponses();
      }
    },
    submitDetails() {
      this.detailsConfirmed = true;
      this.currentStep = 'final';
      this.submitResponses();
    },
    async submitResponses() {
      // Submit to your API endpoint
      const payload = {
        ...this.answers,
        details: this.detailsConfirmed ? this.details : null,
        timestamp: new Date().toISOString()
      };
      
      console.log('Submitting:', payload);
      
      // Example API call:
      // try {
      //   await this.$http.post('/api/user-checkin', payload);
      // } catch (error) {
      //   console.error('Error submitting form:', error);
      // }
    },
    goToNewListing() {
      // Redirect to listing creation page
      this.$router.push('/ny-annons');
    },
    claimDiscount() {
      // Redirect to discount page or open modal
      this.$router.push('/erbjudande');
    }
  }
}
</script>

<style scoped>
.logo-wrap {
  text-align: center;
  border-bottom: 1px solid #f3f2f2;
  background-color: white;
}

.logo-wrap img {
  padding: 15px;
}

.form-container {
  max-width: 600px;
  margin: 40px auto;
  padding: 0 20px;
}

h1 {
  text-align: center;
  color: #333;
  margin-bottom: 40px;
}

.step {
  margin: 40px 0;
}

.question {
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
  line-height: 1.6;
}

.button-group {
  display: flex;
  gap: 15px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  padding: 12px 40px;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn-primary {
  background-color: #4CAF50;
  color: white;
}

.btn-primary:hover {
  background-color: #45a049;
}

.btn-secondary {
  background-color: #f1f1f1;
  color: #333;
}

.btn-secondary:hover {
  background-color: #ddd;
}

.details-form {
  background: #f9f9f9;
  padding: 30px;
  border-radius: 8px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4CAF50;
}

.final-message {
  text-align: center;
  padding: 30px;
}

.success-message {
  font-size: 24px;
  color: #4CAF50;
  margin-bottom: 20px;
  font-weight: 500;
}

.discount-offer {
  background: #e8f5e9;
  padding: 30px;
  border-radius: 8px;
  margin-top: 30px;
}

.discount-offer h3 {
  color: #2e7d32;
  margin-bottom: 15px;
}

@media (max-width: 600px) {
  .form-container {
    padding: 0 15px;
  }
  
  .button-group {
    flex-direction: column;
  }
  
  .btn {
    width: 100%;
  }
}
</style>